import React from "react";
import { CardMedia, Grid, makeStyles } from "@material-ui/core";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";
import Slider from "../../about/common/slider/Slider";
const useStyles = makeStyles((theme) => ({
  dots: {
    justifyContent: "center",
  },
  grid: {
    justifyContent: "center",
  },
  media: {
    height: "7.5em",
    width: "21.5em",
    margin: "1.4em",
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "0.3em auto",
      height: "7.2em",
      width: "20.5em",
    },
  },
}));
const settings = {
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  timeout: 4000,
  breakpoints: {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
};

const TrustedBy = ({ header, paragraph, images }) => {
  const classes = useStyles();
  return (
    <>
      <NtkHeader header={header} />
      <NtkParagraph paragraph={paragraph} />
      <Slider {...settings}>
        {images &&
          images.map(({ image, title }) => (
            <div key={title}>
              <Grid className={classes.grid} container>
                <CardMedia className={classes.media} image={image} />
              </Grid>
            </div>
          ))}
      </Slider>
    </>
  );
};
export default TrustedBy;
